import React from 'react'
import { CheckoutContext } from '../../../contexts/CheckoutContext'
import { Loading } from '../../Simple'
import { PixAprovado, PixCancelado, PixError, PixNaoAprovado, PixPendente } from './StatesPix/'

export default function MobilePix() {
  const { sttCtxChkt, loadCh } = React.useContext(CheckoutContext)
  //console.log('SttCtxChkt :: ', sttCtxChkt)
  return (
    <div className='contain-page-pix'>
      {loadCh.pix ? (
        <div className='contain-loading'>
          <Loading text={'Carregando dados do pagamento...'} />
        </div>
      ) : sttCtxChkt.modePix === 'pendente' ? (
        <PixPendente />
      ) : sttCtxChkt.modePix === 'aprovado' ? (
        <PixAprovado />
      ) : sttCtxChkt.modePix === 'cancelado' ? (
        <PixCancelado />
      ) : sttCtxChkt.modePix === 'nao_aprovado' ? (
        <PixNaoAprovado />
      ) : (
        <PixError />
      )}
    </div>
  )
}
